// P1 — Capa única de tokens semánticos de estado (ADR-P1-001).
// Único punto donde vive la relación (kind, value) -> tone. No reimplementar
// mapas de color de severidad/estado en páginas — importar de aquí.
//
// tones válidos: 'critical'|'high'|'medium'|'low'|'info'|'neutral'|'brand'
export const STATUS_TONE = {
  risk: { critical: "critical", high: "high", medium: "medium", low: "low" },
  impl: { not_started: "neutral", in_progress: "info", implemented: "low", not_applicable: "neutral" },
  doc: { draft: "medium", under_review: "info", approved: "brand", published: "low" },
  audit: { not_assessed: "neutral", compliant: "low", non_compliant: "critical", observation: "medium", not_applicable: "neutral" },
  // Nota-grado (p1-design.md §2): 4ª escala A/B/C/D — B es azul, por eso no colapsa con risk.
  grade: { A: "low", B: "info", C: "medium", D: "critical" },
};

export const getStatusTone = (kind, value) => STATUS_TONE[kind]?.[value] ?? "neutral";

export const getScoreTone = (s) => (s >= 80 ? "low" : s >= 60 ? "medium" : "critical");

// i18n labelKey por (kind,value) — reutiliza las claves ya existentes en i18n/translations.js
// (docs.status.*, audits.checklist.*, in_progress/not_started/... genéricas). `grade` no tiene
// labelKey: la letra A/B/C/D es el label (StatusBadge cae a `value` crudo cuando no hay match).
export const STATUS_LABEL_KEY = {
  risk: { critical: "critical", high: "high", medium: "medium", low: "low" },
  impl: {
    not_started: "not_started",
    in_progress: "in_progress",
    implemented: "implemented",
    not_applicable: "not_applicable",
  },
  doc: {
    draft: "docs.status.draft",
    under_review: "docs.status.under_review",
    approved: "docs.status.approved",
    published: "docs.status.published",
  },
  audit: {
    not_assessed: "audits.checklist.not_assessed",
    compliant: "audits.checklist.compliant",
    non_compliant: "audits.checklist.non_compliant",
    observation: "audits.checklist.observation",
    not_applicable: "audits.checklist.not_applicable",
  },
};

// Recharts necesita hex. Mantener en sync con index.css --critical/high/medium/low/info + --primary.
export const TONE_HEX = {
  critical: "#EF4444",
  high: "#F97316",
  medium: "#EAB308",
  low: "#22C55E",
  info: "#3B82F6",
  neutral: "#64748B",
  brand: "#6B46F6",
};

export const getStatusHex = (kind, value) => TONE_HEX[getStatusTone(kind, value)];
